const flow = require('lodash/fp/flow');
const merge = require('lodash/merge');
const { format, subMonths } = require('date-fns');
const parseRequestMetaData = require('../../utils/parse-request-meta-data');
const apiConfig = require('../../api-config');

const VALUE_MOVEMENT_MONTH_RANGE = 12; // WMCE-46188-setting 12 months for mobile device same as web
const VALUE_MOVEMENT_MONTH_RANGE_WEB = 12;
const DATE_FORMAT = 'YYYY-MM-DD';
const SEPERATOR =  require('../../utils/constants');

function getQS(parsedMetaData) {
  return {
    userId: parsedMetaData.qs.userId,
    destinationCurrency: parsedMetaData.qs.destinationCurrency,
    pfRelId: parsedMetaData.portfolio.pfRelId,
    branchCode: parsedMetaData.portfolio.branchCode,
  };
}

function apiFactory({
  baseUrl,
  requestHandler,
  baseUrlForEntitlement,
  baseUrlForUserProfile,
  baseUrlForGlobalauth,
  baseUrlForTrades

}) {
  const headers = {
    Accept: 'application/json',
  };
  const reqOpts = { headers, method: 'GET' };

  const requestArray = flow(
    requestHandler,
    x => x.catch(e => {
      if (e.statusCode === 404) return [];
      throw e;
    })
  );

  function getUrl(endpoint) {
    return `${baseUrl}${endpoint}`;
  }

  function getUrlForEntitlement(endpoint) {
    return `${baseUrlForEntitlement}${endpoint}`;
  }

  function getUrlForUserProfile(endpoint) {
    return `${baseUrlForUserProfile}${endpoint}`;
  }

  function getUrlForGlobalauth(endpoint) {
    return `${baseUrlForGlobalauth}${endpoint}`;
  }

  function getUrlForTrades(endpoint) {
    return `${baseUrlForTrades}${endpoint}`;
  }

  return {
    getUserPortfolioRelations(metaData) {
      const parsedMetaData = parseRequestMetaData(metaData);
      const url = getUrl('user-portfolio-relations');
      const reqOpts = { headers, method: 'POST', json:true };
      const body = {
        userId: parsedMetaData.qs.userId,
        channel: parsedMetaData.channel
      }
      return requestArray(merge(
        {},
        reqOpts,
        { url, body },
        parseRequestMetaData(metaData)
      ));
    },

    getOverallMarketValue(portfolioId, metaData) {
      const url = getUrl('overall-market-value');
      const parsedMetaData = parseRequestMetaData(metaData);
      const reqOpts = { headers, method: 'POST', json:true };
      const body = {
        userId: parsedMetaData.qs.userId,
        pfRelId: parsedMetaData.portfolio.pfRelId,
        branchCode: parsedMetaData.portfolio.branchCode,
        destinationCurrency: parsedMetaData.qs.destinationCurrency
      };

      return requestHandler(merge(
        {},
        reqOpts,
        { url, body },
        parsedMetaData
      ));
    },

    getPortfolioValueMovement(portfolioId, metaData) {
      const currentDate = (new Date()).toISOString();
      var pastDate;
      const reqOpts = { headers, method: 'POST', json:true };
      const url = getUrl('portfolio-value-movement');
      const parsedMetaData = parseRequestMetaData(metaData);
      const channel = parsedMetaData.channel;

      if(channel == 'WEB'){
        pastDate = subMonths(currentDate, VALUE_MOVEMENT_MONTH_RANGE_WEB);
      }
      else
        pastDate = subMonths(currentDate, VALUE_MOVEMENT_MONTH_RANGE);

      const toDate = format(currentDate, DATE_FORMAT);
      const fromDate = format(pastDate, DATE_FORMAT);
      const body = Object.assign({}, getQS(parsedMetaData), { toDate, fromDate });

      return requestArray(merge(
        {},
        reqOpts,
        { url, body },
        parsedMetaData
      ));
    },

    getAssetMarketValue(portfolioId, metaData) {
      const url = getUrl('asset-market-value');
      const parsedMetaData = parseRequestMetaData(metaData);
      const body = {
        userId: parsedMetaData.qs.userId,
        pfRelId: parsedMetaData.portfolio.pfRelId,
        branchCode: parsedMetaData.portfolio.branchCode,
        destinationCurrency: parsedMetaData.qs.destinationCurrency,
        language: parsedMetaData.portfolio.language
      };
      const reqOpts = { headers, method: 'POST', json: true };
      return requestArray(merge(
        {},
        reqOpts,
        { url, body },
        parsedMetaData
      ));
    },

    getPortfoliosPerfChartData(portfolioId, metaData) {
      //debugger;
      const url = getUrl('portfolio-performance');
      const reqOpts = { headers, method: 'POST', json: true };
      const parsedMetaData = parseRequestMetaData(metaData);
      const body = {
        userId: parsedMetaData.qs.userId,
        pfRelId: parsedMetaData.portfolio.pfRelId,
        branchCode: parsedMetaData.portfolio.branchCode,
        destinationCurrency: parsedMetaData.qs.destinationCurrency,
        channel:  parsedMetaData.channel,
      };

      return requestArray(merge(
        {},
        reqOpts,
        { url, body },
        parsedMetaData
      ));
    },


    getCollateralSurplus(portfolioId, metaData) {
      const url = getUrl('collateral-surplus');
      const parsedMetaData = parseRequestMetaData(metaData);
      const qs = getQS(parsedMetaData);

      return requestArray(merge(
        {},
        reqOpts,
        { url, qs },
        parsedMetaData
      ));
    },

    getCurrencyExposure(portfolioId, metaData) {
      const url = getUrl('portfolio-currency-exposure');
      const reqOpts = {headers, method: 'POST', json: true }
      const parsedMetaData = parseRequestMetaData(metaData);
      const body = {
        userId: parsedMetaData.qs.userId,
        pfRelId: parsedMetaData.portfolio.pfRelId,
        branchCode: parsedMetaData.portfolio.branchCode,
        destinationCurrency: parsedMetaData.qs.destinationCurrency
      };

      return requestHandler(merge(
        {},
        reqOpts,
        { url, body },
        parsedMetaData
      ));
    },

    getServerTimeEntitlementEdelPortfolio(meta) {
      let urls = [];
      if(apiConfig.branchCode === 1){
         urls = [
          getUrlForGlobalauth('getSecondFactorAuthServerTime'),
          getUrlForEntitlement('user-entitlement'),
          getUrlForUserProfile('get-user-pref-edelivery'),
          getUrl('user-portfolio-relations'),
        ];
      }else{
         urls = [
          getUrlForGlobalauth('getSecondFactorAuthServerTime'),
          getUrlForEntitlement('user-entitlement'),
          getUrl('user-portfolio-relations'),
        ];
      }

      const opts = { headers, method: 'POST', json: true }
      const parsedMetaData = parseRequestMetaData(meta);
      const body = {
        userId: parsedMetaData.qs.userId,
        branchCode: apiConfig.branchCode,
      };

      return Promise.all(urls.map(url => requestHandler(merge(
        {},
        opts,
        { url, body },
        parsedMetaData
      ))
      ))
    },

    getCcyDiscoveryTermsRmia(language, metaData) {
      const urls = [
        getUrlForUserProfile('user-discovery-status'),
        getUrlForUserProfile('get-user-pref-refccy'),
        getUrlForUserProfile('show-termsconditions'),
        getUrlForUserProfile('user-rmia-details'),
      ];
      const opts = { headers, method: 'POST', json: true }
      const parsedMetaData = parseRequestMetaData(metaData);
      const body = {
        userId: parsedMetaData.qs.userId,
        branchCode: apiConfig.branchCode,
        language : language,
      };

      return Promise.all(urls.map(url => requestHandler(merge(
        {},
        opts,
        { url, body },
        parsedMetaData
      ))
      ))
    },

    portfoliosAndStatusData(inputParam, metaData) {

      const urls = [
        getUrl('portfolios-cashaccounts/search'),
        getUrlForTrades('statuses')
      ];
      const parsedMetaData = parseRequestMetaData(metaData);
      const reqOpts = {
        headers: merge(headers, parsedMetaData.headers),
        method: 'POST',
        json: true
      };
      const params = inputParam.split(SEPERATOR.SEPERATOR);
      const modules = params[0];
      const portfolioTypes = params[1];
      const channel = params[2];

      const body = {
        language: parsedMetaData.portfolio.language,
        branchCode: parsedMetaData.portfolio.branchCode,
        userId: parsedMetaData.qs.userId,
        modules: [ modules ],
        portfolioTypes: [],
        channel: channel
      }

      return Promise.all(urls.map(url => requestHandler(merge(
        {},
        reqOpts,
        { url, body },
        parsedMetaData
      ))
      ))
    }

  };
}

module.exports = apiFactory;
